import React, { useState, useEffect, Fragment, useRef } from 'react';
import { I18N, I18NConsumer } from 'commons';
import { orgId, Ajax, setPageTitle } from 'utils';
import PropTypes from 'prop-types';
import FieldErrorMessage from 'components/forms/FieldErrorMessage';
import * as yup from 'yup';
import cs from 'classnames';
import Alert from 'commons/Alert'

export default function ForgotUsername({ orgName }) {
  const [registerEmail, setRegisterEmail] = useState('');
  const [invalidMsg, setInvalidMsg] = useState('');
  const [alert, setAlert] = useState({});
  const [isSendSucc, setIsSendSucc] = useState(false);
  const [emailError, setEmailError] = useState('')
  const errorContainer = useRef(null)
  const inputRef = React.createRef();

  const schema = yup.object().shape({
    email: yup
      .string()
      .required('jquery.validation.field.required, ssp.register.registration.email')
      .email('jquery.validation.email'),
  });
  let timer;
  const emailValidate = value => {
    schema.validate({ email: value }).then(() => {
      timer = setTimeout(() => {
        const url = `/${orgId}/forgotUsername/validateEmail?email=${value}`;
        Ajax.get(url).then(({ data: res }) => {
          setInvalidMsg(res ? '' : 'ssp.forgotUsername.email.invalid');
        });
      }, 300);
    }).catch(err => {
      setInvalidMsg(err.message);
    });
  };

  const sendEmail = () => {
    const url = `/${orgId}/forgotUsername/sendEmail`;
    const data = new FormData();
    data.append('email', registerEmail);
    Ajax.post(url, data).then(({ data: res }) => {
      switch (res.status) {
        case 1:
          setAlert({
            ...alert,
            type: 'success',
            msg: 'ssp.forgotUsername.send.success'
          });
          setIsSendSucc(true);
          break;
        case 2:
          setAlert({
            ...alert,
            type: 'success',
            msg: 'ssp.forgotUsername.send.success.sso'
          });
          setIsSendSucc(true);
          break;
        case 3:
          setAlert({
            ...alert,
            type: 'success',
            msg: 'ssp.forgotUsername.send.note.sso'
          });
          setIsSendSucc(true);
          break;
        default:
          setAlert({
            ...alert,
            type: 'danger',
            msg: 'ssp.forgotUsername.send.error'
          });
      }
    }).catch(err => {
      console.log(err);
      setAlert({
        ...alert,
        type: 'danger',
        msg: 'ssp.forgotUsername.send.error'
      });
    });
  };
  const handleSubmit = () => {
    clearTimeout(timer);
    schema.validate({ email: registerEmail }).then(() => {
      const url = `/${orgId}/forgotUsername/validateEmail?email=${registerEmail}`;
      Ajax.get(url).then(({ data: res }) => {
        setInvalidMsg(res ? '' : 'ssp.forgotUsername.email.invalid');
        setEmailError(res ? '' : 'ssp.forgotUsername.email.invalid')
        if (res) {
          sendEmail()
        } else {
          errorContainer.current.focus()
        }
      });
    }).catch(err => {
      setInvalidMsg(err.message);
      setEmailError(err.message)
      errorContainer.current.focus()
    });
  };

  return (
    <div className="container">
      <I18NConsumer>
        {(i18n) => setPageTitle(`${orgName} - ${i18n['ssp.title.forgotUsername']}`)}
      </I18NConsumer>
      <div className="well ssp-well login-form">
        <div className="offset-md-1 col-md-11">
          <div>
            <h1 className="h1" id="forgotUsernameTitle"><I18N>ssp.title.forgotUsername</I18N></h1>
            <div className="text-muted" id="forgotUsernameTip">
              <p>
                <I18N>ssp.forgotUsername.tip</I18N>
              </p>
              {
                !isSendSucc &&
                <p>
                  <I18N>form.fields.are.required</I18N>
                </p>
              }
            </div>
          </div>
          <div aria-live="assertive">
            {
              alert.msg &&
              <div className="row">
                <div className="col-md-8">
                  <Alert type={alert.type || 'warning'} message={alert.msg} role="alert" />
                </div>
              </div>
            }
            <div className="row" ref={errorContainer} tabIndex="-1">
              <div className="col-md-8">
                {
                  !!emailError &&
                  <div className="error-container">
                    <p id="error-instruction" className="mb-1">
                      <I18N>form.error.messages.group.title</I18N>
                    </p>
                    <ul id="error-list">
                      <li><I18N>{emailError}</I18N></li>
                    </ul>
                  </div>
                }
              </div>
            </div>
            {!isSendSucc &&
            <form
              className="form-horizontal margin30-T"
              autoComplete="off"
              eb-test="ssp_forgot_username_form"
              onSubmit={e => { e.preventDefault(); }}
            >
              <div className="form-group row">
                <div className="col-md-8">
                  <label htmlFor="email" className="col-form-label">
                    <span id="emailLabel"><I18N>ssp.register.registration.email</I18N></span>
                    <span aria-hidden="true" className="required-star">*</span>
                    <span className="sr-only"><I18N>information.label.required</I18N></span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className={cs({ 'form-control': true, valid_error: invalidMsg })}
                    id="email"
                    value={registerEmail}
                    onChange={e => setRegisterEmail(e.target.value)}
                    onBlur={e => emailValidate(e.target.value)}
                    aria-invalid={!!invalidMsg}
                    maxLength="80"
                    required
                    ref={inputRef}
                    eb-test="ssp_forgot_username_field_email"
                    {...(invalidMsg ? { 'aria-describedby': 'invalidMsg' } : {})}
                  />
                  {
                    invalidMsg &&
                  <FieldErrorMessage id="invalidMsg" aria-live="assertive"><I18N>{invalidMsg}</I18N></FieldErrorMessage>
                  }
                </div>
              </div>
              <div className="form-group row">
                <div className="offset-md-3 col-md-5 mt-3">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={handleSubmit}
                    eb-test="ssp_forgot_username_button_submit"
                  >
                    <I18N>ssp.button.send</I18N>
                  </button>
                </div>
              </div>
            </form>
            }
          </div>

        </div>
      </div>
    </div>
  );
}

ForgotUsername.propTypes = {
  orgName: PropTypes.string.isRequired
};
